import template from './organizationsList.template.html';

export default {
  template,
  bindings: {
    organizations: '=',
    onClick: '&',
    onReady: '&',
    onToggle: '&',
    onDelete: '&'
  },
  controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listService, uiService, INSTANCE) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.INSTANCE = INSTANCE;
      ctrl.IsEnterprise = $rootScope.IsEnterprise;
      ctrl.CurrentAccount = null;
      ctrl.$mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.list = listService;
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.CurrentAccount = $rootScope.CurrentAccount;
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.organizations, ctrl.list.getGroupingByFirstLetter())
        );
        var len = ctrl.organizations.length;
        while (len--) {
          ctrl.organizations[len].isDefault = ctrl.isDefault(ctrl.organizations[len]);
        }
        ctrl.onReady({ list: ctrl.list });
      };
      this.click = function ($event, data) {
        ctrl.onClick({ event: $event, data: data });
      };
      this.toggle = function ($event, data) {
        ctrl.CurrentAccount.idDefaultOrganization = data.id;
        uiService.scopeApply(function () {
          var len = ctrl.organizations.length;
          while (len--) {
            if (ctrl.organizations.id !== data.id) {
              ctrl.organizations[len].isDefault = ctrl.isDefault(ctrl.organizations[len]);
              if (ctrl.organizations[len].isDefault) {
                ctrl.onToggle({ data: data });
              }
            }
          }
        });
      };
      this.delete = function ($event, data) {
        ctrl.onDelete({ event: $event, data: data });
      };

      /*
       * Helper Methods
       * --------------------------------------------------------------------------------
       */
      this.isDefault = function (organization) {
        return ctrl.CurrentAccount.idDefaultOrganization === organization.id;
      };
      this.isOwner = function (organization) {
        return ctrl.CurrentAccount.id === organization.idOwner;
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {
        if (changes.organizations && changes.organizations.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
